// import { createBrowserHistory } from 'history'
// const history = createBrowserHistory()

// export const History = history

import { BrowserRouter } from 'react-router-dom'
import { createBrowserHistory } from 'history'

export const history = createBrowserHistory()

export default class History extends BrowserRouter {
  history
}
